

















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class DefaultTableButton extends Vue {
  @Prop({ default: () => [] })
  private items!: any[];
  @Prop({ default: "cog" })
  public icon!: string;
  @Prop({ default: "is-bottom-left" })
  public position!: string;

  public get filteredItems() {
    return this.items.filter(i => {
      if (this.$_.has(i, "if")) return i.if;
      return true;
    });
  }
}
